<template>
	<div>
		<action-sidebar
			:title="$route.meta.title"
			:value="true"
			:width="500"
			@close-modal="closeModal"
		>
			<accounting-edit
				:id-account="id"
				:subsidiary-id="subsidiaryId"
				:disableSaveButton="disableSaveButton"
				@update-account="updateAccount"
			/>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import accountingEdit from '@/components/accounting-plans/accounting-edit';
import r from '@/pages/accounting-plans/export-retentions';

function closeModal() {
	this.goTo('accounting-plans', { params: { subsidiaryId: this.subsidiaryId } });
}

async function updateAccount(model, id, validate) {
	console.log('id::: ', id);
	console.log('model::: ', model);
	this.disableSaveButton = true;
	const method = id ? 'patch' : 'post';
	const url = id ? `com-accounting-plan/${id}` : 'com-accounting-plan';
	const action = id ? 'actualizó' : 'creó';
	const newModel = { ...model };
	if (!id) {
		newModel.subsidiaryId = Number(this.subsidiaryId);
	}
	try {
		const response = await this.$http[method](url, newModel);
		if (!id && !!validate) {
			await this.$http.patch(`com-accounting-plan/${response.data.id}/active`);
			const allaccounts = await this.$http.get(`com-accounting-accounts/${response.data.id}/plan`);
			console.log('allaccounts::: ', allaccounts);
			const accCustomer = this.findAccount(allaccounts.data, '1.1.2.01.001');
			const accSupplier = this.findAccount(allaccounts.data, '2.1.1.01.001');
			const accCheque = this.findAccount(allaccounts.data, '1.1.1.02.001');
			const accCash = this.findAccount(allaccounts.data, '1.1.1.01.001');
			const accBank = this.findAccount(allaccounts.data, '1.1.1.02.001');
			const accCostsWithTax = this.findAccount(allaccounts.data, '5.1.1.01.001');
			const accCostsWithOutTax = this.findAccount(allaccounts.data, '5.1.1.01.002');
			const accDiscountWithTax = this.findAccount(allaccounts.data, '4.1.1.01.003');
			const accDiscountWithOutTax = this.findAccount(allaccounts.data, '4.1.1.01.004');
			const accInventoryWithTax = this.findAccount(allaccounts.data, '1.1.3.01.001');
			const accInventoryWithOutTax = this.findAccount(allaccounts.data, '1.1.3.01.002');
			const accProcessWithTax = this.findAccount(allaccounts.data, '4.1.1.01.005');
			const accProcessWithOutTax = this.findAccount(allaccounts.data, '4.1.1.01.006');
			const accRepaymentWithTax = this.findAccount(allaccounts.data, '4.1.1.01.005');
			const accRepaymentWithOutTax = this.findAccount(allaccounts.data, '4.1.1.01.006');
			const accSalesWithTax = this.findAccount(allaccounts.data, '4.1.1.01.001');
			const accSalesWithOutTax = this.findAccount(allaccounts.data, '4.1.1.01.002');
			const newSettings = {
				companyId: response.data.companyId,
				customerId: response.data.customerId,
				subsidiaryId: response.data.subsidiaryId,
				productsSettings: {
					costs: {
						iva: accCostsWithTax.id,
						withoutIva: accCostsWithOutTax.id,
					},
					discount: {
						iva: accDiscountWithTax.id,
						withoutIva: accDiscountWithOutTax.id,
					},
					inventory: {
						iva: accInventoryWithTax.id,
						withoutIva:	accInventoryWithOutTax.id,
					},
					process: {
						iva: accProcessWithTax.id,
						withoutIva:	accProcessWithOutTax.id,
					},
					repayment: {
						iva: accRepaymentWithTax.id,
						withoutIva: accRepaymentWithOutTax.id,
					},
					sales: {
						iva: accSalesWithTax.id,
						withoutIva: accSalesWithOutTax.id,
					},
				},
				settings: [
					{
						suppliers: {
							id: accSupplier.id,
							account: accSupplier.account,
							accountName: accSupplier.name,
						},
						customers: {
							id: accCustomer.id,
							account: accCustomer.account,
							accountName: accCustomer.name,
						},
						cheque: {
							id: accCheque.id,
							account: accCheque.account,
							accountName: accCheque.name,
						},
						cash: {
							id: accCash.id,
							account: accCash.account,
							accountName: accCash.name,
						},
						bank: {
							id: accBank.id,
							account: accBank.account,
							accountName: accBank.name,
						},
					},
				],
			};
			await this.$http.patch(`settings/${response.data.customerId}/${response.data.subsidiaryId}`, newSettings);
			const token = JSON.parse(localStorage.getItem('cs'));
			const accountingAccount = {
				costs: {
					iva: accCostsWithTax.id,
					withoutIva: accCostsWithOutTax.id,
				},
				discount: {
					iva: accDiscountWithTax.id,
					withoutIva: accDiscountWithOutTax.id,
				},
				inventory: {
					iva: accInventoryWithTax.id,
					withoutIva:	accInventoryWithOutTax.id,
				},
				process: {
					iva: accProcessWithTax.id,
					withoutIva:	accProcessWithOutTax.id,
				},
				repayment: {
					iva: accRepaymentWithTax.id,
					withoutIva: accRepaymentWithOutTax.id,
				},
				sales: {
					iva: accSalesWithTax.id,
					withoutIva: accSalesWithOutTax.id,
				},
			};
			this.accountingAccount = {
				accountingAccount,
			};
			await this.$httpProducts.patch(`products/accounting-account?flagForceUpdate=${true}`, this.accountingAccount,
				{ headers: { Authorization: `Bearer ${token.filters.aclCredentials.company.hash}` } },
			);
			const customerParams = {
				accountingCode: accCustomer.code,
				accountingAccount: { id: accCustomer.id },
			};
			await this.$httpSales.patch(`customers/accounting-code?flagForceUpdate=${true}`, customerParams,
				{ headers: { Authorization: `Bearer ${token.filters.aclCredentials.company.hash}` } },
			);
			const cashParams = {
				id: accCash.id,
				name: accCash.name,
				account: accCash.account,
			};
			await this.$httpSales.patch(`cash/accounting-account?flagForceUpdate=${true}`, { accountingAccount: cashParams },
				{ headers: { Authorization: `Bearer ${token.filters.aclCredentials.company.hash}` } },
			);
			const bankParams = {
				codeBank: accBank.id,
				codeCheck: accCheque.id,
			};
			await this.$httpSales.patch(`bank-accounting-account?flagForceUpdate=${true}`, { accountingAccount: bankParams },
				{ headers: { Authorization: `Bearer ${token.filters.aclCredentials.company.hash}` } },
			);
			const addAccSu = {
				id: accSupplier.id,
				name: accSupplier.name,
			};
			const accountingCode = accSupplier.code;
			const suppliersParams = {
				accountingAccount: addAccSu,
				accountingCode,
			};
			await this.$httpSales.patch(`suppliers/accounting-account?flagForceUpdate=${true}`, suppliersParams,
				{ headers: { Authorization: `Bearer ${token.filters.aclCredentials.company.hash}` } },
			);
			const serviceData = this.transformToServiceData(r, allaccounts.data);
			await this.$httpSales.post('withholding-company-multiple', serviceData,
				{ headers: { Authorization: `Bearer ${token.filters.aclCredentials.company.hash}` } },
			);
			let rules = await this.$http.get(`rules?customerId=${response.data.customerId}&page=1&limit=15&search=iva&subsidiaryId=${this.subsidiaryId}`);
			rules = rules.data.map((w) => {
				const nR = { ...w };
				if (nR.code === 'IVAVENTAS-NTC15%' || nR.code === 'IVAVENTAS') {
					nR.acc = '2.1.1.08.002';
				}
				if (nR.code === 'IVA' || nR.code === 'IVACOMPRASNTC') {
					nR.acc = '1.1.2.03.001';
				}
				return nR;
			});
			await this.updateAccountingRules(rules, allaccounts.data).then(console.log);
			let rulesC = await this.$http.get(`rules?customerId=${response.data.customerId}&page=1&limit=15&search=COMMISION&subsidiaryId=${this.subsidiaryId}`);
			rulesC = rulesC.data.map((w) => {
				const nR = { ...w };
				if (nR.code === 'COMMISION') {
					nR.acc = '5.1.5.01.002';
				}
				return nR;
			});
			await this.updateAccountingRules(rulesC, allaccounts.data).then(console.log);
		}
		this.showNotification(`Se ${action} correctamente`);
		this.closeModal();
	} catch (error) {
		if (error.status === 500) {
			this.showGenericError();
		} else if (error.status === 400) {
			if (error.data.message === 'SUBSIDIARY_NOT_FOUND') {
				this.showGenericError('La sucursal no existe.');
			} else if (error.data.message === 'FILE_XLSX_ITEM_EMPTY') {
				this.showGenericError('Un item del archivo se encuentra vacío.');
			}
		}
		this.disableSaveButton = false;
	}
}

async function updateAccountingRules(dataArray, accountsData) {
	const updates = await dataArray.reduce(async (promiseChain, item) => {
		const accumulatedUpdates = await promiseChain;
		// Buscar la cuenta contable
		const accountInfo = this.findAccount(accountsData, item.acc);
		console.log('accountInfo::: ', accountInfo);
		if (!accountInfo) {
			return [...accumulatedUpdates, {
				id: item.id,
				status: 'skipped',
				reason: 'Account not found',
			}];
		}
		// Crear objeto de actualización
		const updateData = {
			entity: item.entity,
			valueEntity: item.valueEntity,
			accountingAccount: `'${accountInfo.code}'`,
			code: item.code,
			concept: item.concept,
			description: item.description,
			formula: item.formula,
			originAccount: item.originAccount,
			reference: item.reference,
			terms: item.terms,
			moduleId: item.moduleId,
		};
		try {
			const response = await this.$http.patch(`rules/${item.id}`, updateData);
			return [...accumulatedUpdates, {
				id: item.id,
				status: 'success',
				response: response.data,
			}];
		} catch (error) {
			return [...accumulatedUpdates, {
				id: item.id,
				status: 'error',
				error: error.message,
			}];
		}
	}, Promise.resolve([]));
	return updates;
}

function transformToServiceData(originalData, accountData) {
	console.log('accountData::: ', accountData);
	console.log('originalData::: ', originalData);
	return {
		accountingAccount: originalData
			.filter(item => item.COMP || item.VENTA) // Solo items con COMP o VENTA
			.map((item) => {
				// Buscar la cuenta de compras
				const compAccount = item.COMP ? this.findAccount(accountData, item.COMP) : null;
				// Buscar la cuenta de ventas
				const vtaAccount = item.VENTA ? this.findAccount(accountData, item.VENTA) : null;
				return {
					code: item.code, // Convertir a número si es posible
					accountPurchases: compAccount ? compAccount.id : '',
					accountSales: vtaAccount ? vtaAccount.id : '',
					accountNameSales: vtaAccount ? `${vtaAccount.name} - ${item.VENTA}` : '',
					accountNamePurchases: compAccount ? `${compAccount.name} (${item.code}) - ${item.COMP}` : '',
					account: compAccount.account || '',
					accountVta: vtaAccount.account || '',
				};
			}),
	};
}

function findAccount(val, targetAccount) {
	let foundItem = null;
	const newData = val;
	newData.forEach((item) => {
		// Si ya se encontró el item, no continuar buscando
		if (foundItem) return;
		// Si coincide el account, asignar a foundItem
		if (item.account === targetAccount) {
			foundItem = item;
			return;
		}
		// Si tiene children, buscar recursivamente
		if (item.children && item.children.length > 0) {
			const childResult = findAccount(item.children, targetAccount);
			if (childResult) {
				foundItem = childResult;
			}
		}
	});
	return foundItem;
}

function data() {
	return {
		disableSaveButton: false,
		accountingAccount: null,
	};
}

export default {
	name: 'page-accounting-edit',
	components: {
		actionSidebar,
		accountingEdit,
	},
	data,
	methods: {
		closeModal,
		findAccount,
		updateAccountingRules,
		transformToServiceData,
		updateAccount,
	},
	props: {
		subsidiaryId: [String, Number],
		id: [String, Number],
	},
};
</script>




// WEBPACK FOOTER //
// src/pages/accounting-plans/page-accounting-edit.vue